<template>
  <el-dialog
    :visible="dialogVisible"
    width="600px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="versionform" :rules="rules" :model="version">
      <el-form-item prop="version" label="版本号" :label-width="formLabelWidth">
        <el-input v-model="version.version" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="versionAlias" label="版本别名" :label-width="formLabelWidth">
        <el-input v-model="version.versionAlias" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="enable" label="可用性" :label-width="formLabelWidth">
        <el-switch v-model="version.enable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="version.description" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="template" label="模版" :label-width="formLabelWidth">
        <codemirror v-model="version.template" :options="cmOptions" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { createAppVersion } from '@/api/app';
import { errorHandle } from '@/utils/error';
// import language js
import 'codemirror/mode/javascript/javascript.js'
// import theme style
import 'codemirror/theme/base16-dark.css'
const yaml = require('js-yaml');
export default {
  name: 'EditAppVersion',
  props: {
    appID: String,
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    const checkVersion = (rule, value, callback) => {
      if (!value) {
        callback('版本号不符合标准格式，比如 1.0')
      }
      if (value.startsWith('.')) {
        callback('版本号不符合标准格式，比如 1.0')
      }
      if (value.endsWith('.')) {
        callback('版本号不符合标准格式，比如 1.0')
      }
      const versionNum = Number(value.replace('.', ''))
      if (!versionNum || versionNum == 0) {
        callback('版本号不符合标准格式，比如 1.0')
      }
      callback()
    }
    const checkTemplate = (rule, value, callback) => {
      try {
        const template = yaml.load(value)
        if (!template.spec.url) {
          callback('spec.url 是必填项')
        }
        if (!template.spec.createUser.path) {
          callback('spec.createUser.path 是必填项')
        }
        if (template.spec.lockUser && !template.spec.lockUser.path) {
          callback('spec.lockUser.path 是必填项')
        }
        if (template.spec.deleteUser && !template.spec.deleteUser.path) {
          callback('spec.deleteUser.path 是必填项')
        }
        callback()
      } catch (err) {
        callback('不符合yaml格式' + err)
      }
    }
    return {
      version: {
        versionAlias: '',
        enable: false,
        description: '',
        version: '',
        templateType: 'SAAS',
        template: ''
      },
      cmOptions: {
        tabSize: 4,
        mode: 'text/javascript',
        theme: 'base16-dark',
        lineNumbers: true,
        cursorHeight: '20px',
        line: true
      },
      rules: {
        version: [
          { min: 2, max: 20, message: '版本号应该处于2-20个字符之间', trigger: 'blur' },
          { validator: checkVersion, message: '版本号不符合标准格式，比如 1.0', trigger: 'blur' }
        ],
        enable: [],
        versionAlias: [
          { min: 2, max: 255, message: '分类名称必须大于1个字符', trigger: 'blur' }
        ],
        description: [
          { min: 2, max: 255, message: '描述最多255个字符', trigger: 'blur' }
        ],
        template: [
          { required: true, message: '版本模版是必须的', trigger: 'blur' },
          { validator: checkTemplate, trigger: 'blur' }
        ]
      },
      title: '添加SaaS版本',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {
    const defaultTemplate = {
      kind: 'SaaSVersionModel',
      metadata: {
        name: 'rainbondcluster'
      },
      apiVersion: 'rainbond.io/v1alpha1',
      spec: {
        url: '',
        createUser: {
          path: '',
          retry: 3,
          header: {
            Authorization: ''
          },
          method: 'POST',
          requestBody: ''
        },
        lockUser: {
          path: '',
          retry: 3,
          header: {
            Authorization: ''
          },
          method: 'PUT',
          requestBody: ''
        },
        deleteUser: {
          path: '',
          retry: 3,
          header: {
            Authorization: ''
          },
          method: 'DELETE',
          requestBody: ''
        }
      }
    }
    this.version.template = yaml.dump(defaultTemplate)
  },
  methods: {
    submit() {
      this.Loading = true;
      this.$refs.versionform.validate(valid => {
        if (valid) {
          this.version.marketID = this.marketID
          this.version.appID = this.appID
          const data = Object.assign(this.version, { template: yaml.load(this.version.template) })
          createAppVersion(data)
            .then(res => {
              this.Loading = false;
              this.onSuccess && this.onSuccess()
            })
            .catch(err => {
              this.Loading = false;
              errorHandle(err)
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.versionform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
 .CodeMirror-line {
   line-height: 20px!important;
 }
  ::v-deep .el-form-item__content {
   line-height: 20px!important;
 }
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/addAppSaaSVersion.vue